import { apiMillennium } from '../../api'

const BoardingNow = async () => {
	const res = await apiMillennium.get('/embarcados_agora')
	return res
}

export default BoardingNow;